import styled from 'styled-components'
import Select from 'react-select'

export const Bg = styled.div`
  min-height: 100vh;
  width: 100%;
  background: white;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background: white;
  min-height: 100vh;
`

export const Container = styled.div`
  padding: 0 2rem 3rem;
  display: flex;
  justify-content: center;
`

export const FormCard = styled.div`
  width: 100%;
  max-width: 560px;
  background: white;
  border-radius: 16px;
  border: 1px solid #E8EBF0;
  box-shadow: 0 4px 32px rgba(43,123,199,0.08);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 0.75rem;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`

export const FieldLabel = styled.label`
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
`

export const Input = styled.input`
  height: 2.5rem;
  padding: 0 0.875rem;
  font-family: Poppins;
  font-size: 0.85rem;
  color: #111827;
  background: white;
  border: 1.5px solid #D1D5DB;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:focus {
    border-color: #00C4F3;
    box-shadow: 0 0 0 3px rgba(0,196,243,0.15);
  }
`

export const FeedBack = styled.div`
  font-family: Poppins;
  font-size: 0.72rem;
  color: #EF4444;
`

export const Divider = styled.div`
  height: 1px;
  background: #F0F1F5;
`

export const SectionTitle = styled.p`
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 0.75rem;
`

export const SelectorLicenceContainer = styled.div``

export const LicenceSelector = styled(Select)`
  .react-select__control {
    border-radius: 10px;
    font-family: Poppins;
    font-size: 0.85rem;
    border: 1.5px solid #D1D5DB;
    min-height: 2.5rem;
    cursor: pointer;
    box-shadow: none;
    &:hover { border-color: #9CA3AF; }
  }
  .react-select__control--is-focused {
    border-color: #00C4F3 !important;
    box-shadow: 0 0 0 3px rgba(0,196,243,0.15) !important;
  }
  .react-select__option {
    font-family: Poppins;
    font-size: 0.85rem;
    cursor: pointer;
  }
  .react-select__indicator-separator { display: none; }
  .react-select__dropdown-indicator { color: #9CA3AF; }
`

export const TrainingChoices = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const CheckboxChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: ${p => p.$checked ? '600' : '400'};
  color: ${p => p.$checked ? '#4F46E5' : '#6B7280'};
  background: ${p => p.$checked ? '#EEF2FF' : '#F9FAFB'};
  border: 1.5px solid ${p => p.$checked ? '#C7D2FE' : '#E5E7EB'};
  border-radius: 100px;
  padding: 0.35rem 0.875rem;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
  &:hover {
    border-color: ${p => p.$checked ? '#A5B4FC' : '#D1D5DB'};
    background: ${p => p.$checked ? '#E0E7FF' : '#F3F4F6'};
  }
`

export const CreateBtn = styled.button`
  width: 100%;
  height: 2.75rem;
  font-family: Poppins;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${p => p.disabled ? '#9CA3AF' : 'white'};
  background: ${p => p.disabled ? '#F3F4F6' : 'linear-gradient(135deg, #00C4F3 0%, #6462FC 100%)'};
  border: none;
  border-radius: 12px;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  box-shadow: ${p => p.disabled ? 'none' : '0 4px 16px rgba(100,98,252,0.25)'};
  transition: opacity 0.15s, transform 0.15s;
  &:not(:disabled):hover { opacity: 0.9; transform: translateY(-1px); }
  &:not(:disabled):active { transform: translateY(0); }
`

export const SuccessToast = styled.div`
  position: fixed;
  top: 1.5rem;
  right: 2rem;
  z-index: 1000;
  background: white;
  border: 1px solid #BBF7D0;
  border-radius: 12px;
  padding: 0.875rem 1.25rem;
  box-shadow: 0 8px 32px rgba(22,163,74,0.15);
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #15803D;
  animation: slideIn 0.25s ease;
  @keyframes slideIn {
    from { transform: translateX(2rem); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
  }
`

/* backward compat stubs */
export const FormContainer = styled.div``
export const BoxContainer = styled.div``
export const BoxTitle = styled.div``
export const Success = styled.div``
export const TextSuccess = styled.div``
export const ImgSuccess = styled.img``
export const DeleteInput = styled.img``
export const TrainingLabel = styled.label``
export const TrainingInput = styled.input``
export const TrainingChoice = styled.div``
export const Button = styled.button``
export const ErrorContainer = styled.div``
export const Name = styled.div``
export const Opt = styled.option``
export const ArrowLicence = styled.img``
